export class BaoHiem{
    'id':number;
    'thangNam':Date;
    'slNguoiQuanLy':number;
    'slNguoiLaoDong': number;
    'loaiBaoHiemThang': number;
    'tongTien':number;
    'bhxh':number;
    'bhyt':number;
    'bhtn':number;
    'trangThai':number;
    'idNVKhoiTao':number;
    'tinhTrang':number;
    'ngayKhoiTao':Date;
    'idNVCapNhat':number;
    'ngayCapNhat':Date;
    'ghiChu':string;
    'congDoan': number;
    'thangApDung': Date;
}
export class DsBaoHiem{
    'danhSachBaoHiem':Array<BaoHiem>;
}
export class DsBaoHiemPagingResponse {
    "data": Array<BaoHiem>;
    "recordsTotal": number;
    "maxPage": number;
    "pageCurrent": number;
    "pageListShow": Array<number>;
}
export class ChiTietBaoHiem {
    'id':number;
    'idNhanVien':number;
    'idBaoHiemThang':number;
    'bac':number;
    'heSoLuong':number;
    'mucLuongDongBaoHiem':number;
    'phuCap':number;
    'congDoan':number;
    'nlD_BHXH':number;
    'nlD_BHYT':number;
    'nlD_BHTN':number;
    'dV_BHXH':number;
    'dV_BHYT':number;
    'dV_BHTN':  number;
    'ma':string;
    'hoTen':string;
    'chucVu':string;
    'isQuanLy':boolean;
    'tinhTrang':number;
    'iDNVKhoiTao':number;
    'ngayKhoiTao':Date;
    'iDNVCapNhat':number;
    'ngayCapNhat':Date;
    'ghiChu': string;
    'thangApDung': Date;
}
export class DsChiTietBaoHiem{
    'danhSachChiTietBaoHiem':Array<ChiTietBaoHiem>;
}